export default __webpack_public_path__ + "static/media/style10.452bb6cb.jpg";